export default function hommageInit() {
    const isMobile = () => window.innerWidth < 1024;

    // Créer la popup mobile
    const createPopup = () => {
        const popup = document.createElement('div');
        popup.className = 'hommage-popup';
        popup.innerHTML = `
            <div class="hommage-popup-content">
                <button class="hommage-popup-close" aria-label="Fermer"></button>
                <div class="hommage-popup-name"></div>
                <div class="hommage-popup-dates"></div>
                <div class="hommage-popup-description"></div>
            </div>
        `;
        document.body.appendChild(popup);

        // Fermeture au clic sur le fond ou le bouton
        popup.addEventListener('click', (e) => {
            if (e.target === popup || e.target.closest('.hommage-popup-close')) {
                popup.classList.remove('active');
                document.body.style.overflow = '';
            }
        });

        return popup;
    };

    const popup = createPopup();

    const openPopup = (name, dates, description) => {
        popup.querySelector('.hommage-popup-name').textContent = name;
        popup.querySelector('.hommage-popup-dates').textContent = dates;
        popup.querySelector('.hommage-popup-description').textContent = description;
        popup.classList.add('active');
        document.body.style.overflow = 'hidden';
    };

    document.querySelectorAll('.hommage-ligne').forEach((line, index) => {
        // 1 - Animation scroll infini
        const track = line.querySelector('.hommage-track');

        // Duplique le contenu, 3 fois pour harmoniser la couleur en cas de ligne avec un nombre impair d'éléments
        const clone = track.innerHTML;
        track.innerHTML += clone;
        track.innerHTML += clone;
        track.innerHTML += clone;

        // Calcul des width pour synchronisation boucle infini
        requestAnimationFrame(() => {
            const items = track.children;
            let width = 0;
            // On calcule la largeur de la première moitié seulement car l'animation va à 50%
            for (let i = 0; i < items.length / 2; i++) {
                width += items[i].offsetWidth;
            }
            track.style.setProperty('--scroll-distance', `${width}px`);
            // Direction alternée
            if (index % 2 === 1) {
                line.classList.add('reverse');
            }
        });

        // 2 - Gestion du hover (desktop) et du clic (mobile)

        line.querySelectorAll('.hommage-item').forEach((hommageItem) => {
            const hommageContent = hommageItem.querySelector('.hommage-content');
            if (!hommageContent) return;

            const hommageInnerContent = hommageContent.querySelector('.hommage-inner-content');
            // const hommageInnerPaddingX = 20; // Linked to $hommage-inner-padding-x in _hommage.scss

            // Gestion du clic pour mobile
            hommageItem.addEventListener('click', (e) => {
                if (isMobile()) {
                    e.preventDefault();
                    e.stopPropagation();

                    const name = hommageInnerContent.querySelector('.hommage-inner-name')?.textContent || '';
                    const dates = hommageInnerContent.querySelector('.hommage-inner-dates')?.textContent || '';
                    const description = hommageInnerContent.querySelector('.hommage-inner-description')?.textContent || '';

                    openPopup(name, dates, description);
                }
            });

            // Gestion du hover pour desktop
            hommageContent.addEventListener('mouseenter', () => {
                if (!isMobile()) {
                    const rect = hommageContent.getBoundingClientRect();
                    // Calcul du dépassement
                    let offsetX = 0;
                    // Dépasse à droite
                    if (rect.right > window.innerWidth) {
                        offsetX = window.innerWidth - rect.right;
                    }
                    // Dépasse à gauche
                    if (rect.left < 0) {
                        offsetX = -rect.left;
                        hommageInnerContent.style.transform = `translateX(${offsetX}px)`;
                    }
                    hommageInnerContent.style.width = `calc(100% - ${Math.abs(offsetX)}px)`;
                }
            });

            hommageContent.addEventListener('mouseleave', () => {
                if (!isMobile()) {
                    hommageInnerContent.style.transform = '';
                    hommageInnerContent.style.width = `100%`;
                }
            });
        });
    });
};